import Wykonanie from './Wykonanie';
export default Wykonanie;